import React, { Component } from 'react';
import styled from 'styled-components';
import isEqual from 'lodash.isequal';
import { History } from 'history';
import { Appointment, themes } from 'kb-shared';

import Stepper from '../../Book/components/Stepper';
import { AppointmentCTAFooter } from 'components/Dashboard/AppointmentCTA';
import UpcomingAppointment from 'components/UpcomingAppointment';

type Props = {
  upcomingAppointments: Array<Appointment>;
  refetch: Function;
  history: History;
};

type State = {
  index: number;
  sortedUpcomingAppointments: Array<Appointment>;
};

const apptCompareFn = (a: Appointment, b: Appointment) => {
  // @ts-ignore
  return new Date(a.startTime) - new Date(b.startTime);
};

export default class AppointmentsCarousel extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      index: 0,
      sortedUpcomingAppointments: props.upcomingAppointments.sort(apptCompareFn)
    };
  }

  componentDidUpdate(prevProps: Props) {
    const { upcomingAppointments } = this.props;

    if (!isEqual(prevProps.upcomingAppointments, upcomingAppointments)) {
      this.setState({
        index: 0,
        sortedUpcomingAppointments: upcomingAppointments.sort(apptCompareFn)
      });
    }
  }

  render() {
    const { refetch, history } = this.props;
    const { index, sortedUpcomingAppointments: upcomingAppointments } = this.state;

    const appt = upcomingAppointments[index];

    return (
      <Container>
        <UpcomingAppointment
          appointment={appt}
          key={`dashboard-appt-row-${appt.id}`}
          timeSlot={appt}
          type={appt.appointmentType}
          isConfirmation={false}
          onAppointmentCancelled={() => {
            refetch();
          }}
          onReschedule={() => {
            refetch();
          }}
          hasStepper
        />
        <StepperContainer>
          <Heading>{`Upcoming appointment${upcomingAppointments.length > 1 ? 's' : ''}:`}</Heading>
          {upcomingAppointments.length > 1 && (
            <Stepper
              canGoLeft={index > 0}
              canGoRight={index < upcomingAppointments.length - 1}
              onLeft={() => {
                this.setState({ index: Math.max(index - 1, 0) });
              }}
              onRight={() => {
                this.setState({ index: Math.min(index + 1, upcomingAppointments.length - 1) });
              }}
            />
          )}
        </StepperContainer>
        <AppointmentCTAFooter history={history} />
      </Container>
    );
  }
}

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 360px;
`;

const StepperContainer = styled.div`
  display: flex;
  position: absolute;
  padding: 17px 0px 0px 20px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  z-index: 1;

  width: 320px;

  @media screen and (min-width: ${themes.breakpoints.smallDesktop}) {
    width: 360px;
  }

  @media screen and (min-width: ${themes.breakpoints.phone}) {
    width: 300px;
  }
`;

const Heading = styled.p`
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  font-size: 18px;
  font-weight: 600;
  flex: 1;
  color: ${themes.colors.KBNight};
`;
